import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';

export function text(node: PMNode): { type: 'text'; value: string } {
	const value: string = node.text ?? '';
	return { type: 'text' as const, value };
}
